import { GlobalHomePage } from '@bridebook/web/app-basic/components/global-home/global-home';
import Head from '@bridebook/web/app-basic/components/head/head';
import {
  EdgeCacheTTL,
  basicGSSPWrapper,
} from '@bridebook/web/app-basic/lib/get-basic-server-side-props-wrapper';
import { NextPage } from 'next';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { getCountryFromHeaders } from '@bridebook/toolbox/src/getCountryFromHeaders';
import { AppType } from '@bridebook/web/pages/_app';

interface IProps {
  viewerLocation: CountryCodes;
}

const GlobalHome: NextPage<IProps> = ({ viewerLocation }: IProps) => (
  <>
    <Head />
    <GlobalHomePage viewerLocation={viewerLocation} />
  </>
);

export const getServerSideProps = basicGSSPWrapper<IProps>(
  ['landing'],
  async ({ context }) => {
    const viewerLocation = getCountryFromHeaders(context.req.headers, CountryCodes.GB);
    return {
      props: {
        viewerLocation,
      },
    };
  },
  {
    vercelCacheControl: {
      maxAge: EdgeCacheTTL.WEEK,
      sMaxAge: EdgeCacheTTL.WEEK,
      staleWhileRevalidate: EdgeCacheTTL.WEEK,
    },
    cloudflareCacheControl: {
      maxAge: EdgeCacheTTL.DAY,
      sMaxAge: EdgeCacheTTL.DAY,
      staleWhileRevalidate: EdgeCacheTTL.DAY,
    },
  },
);

GlobalHome.AppType = AppType.Basic;

export default GlobalHome;
